export const LOCATION = 'location';
export const DETAILS = 'details';
